import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { ProjectWorkflowDataGridService } from '@piqet-angular/features';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-new-manage-project-workflow',
  templateUrl: './new-manage-project-workflow.component.html',
  styleUrls: ['./new-manage-project-workflow.component.scss'],
})
export class NewManageProjectWorkflowComponent {
  @Output() saveManageProjectWorkFlowEvent = new EventEmitter<any>();
  modalLabel: any;
  submitted = false;
  isShowError = false;

  isPublicValue = false;
  manageProjectWorkflowAddEditForm!: FormGroup;
  manageProjectWorkFlowData: any;
  positionval: any;
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;
  isEdit: any;
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private cookieService: CookieService,
    private projectWorkflowDataGridService: ProjectWorkflowDataGridService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.manageProjectWorkFlowData =
      this.modal?.modalService?.config?.initialState?.['manageProjectWorkflowData'];
    this.isEdit = this.modal?.modalService?.config?.initialState?.['isEdit'];
    this.isPublicValue =
      this.modalLabel == 'Review project status detail'
        ? this.manageProjectWorkFlowData.ispublic
        : false;
  }

  ngOnInit(): void {
    this.showEdit = this.projectWorkflowDataGridService.isAccess('edit');
    this.showCreate = this.projectWorkflowDataGridService.isAccess('create');
    this.showView = this.projectWorkflowDataGridService.isAccess('view');
    this.checkEntireAccess =
      (this.showCreate && !this.isEdit) ||
      (this.isEdit && this.showEdit) ||
      (this.isEdit && !this.showView);
    this.manageProjectWorkflowAddEditForm = this.formBuilder.group({
      label: [
        this.manageProjectWorkFlowData.label || '',
        [Validators.required, noWhitespaceValidator],
      ],
      position: ['', [Validators.required, noWhitespaceValidator, Validators.min(1)]],
    });
    this.setFormData();
  }

  setFormData() {
    this.manageProjectWorkflowAddEditForm.patchValue({
      position: this.manageProjectWorkFlowData.position,
    });
  }

  onClose() {
    this.modal.close();
  }

  isPublic(event: any) {
    this.isPublicValue = event.target.checked;
  }

  onSave() {
    this.submitted = true;
    this.positionval = this.manageProjectWorkflowAddEditForm.value.position;
    const data = this.positionval.toString().includes('.');
    data ? (this.isShowError = true) : (this.isShowError = false);
    if (this.manageProjectWorkflowAddEditForm.valid) {
      const manageProjectWorkFlowAddEditPayload = {
        statusId: this.manageProjectWorkFlowData.statusId || 0,
        label: this.manageProjectWorkflowAddEditForm.controls['label'].value.trimStart(),
        position: this.manageProjectWorkflowAddEditForm.controls['position'].value,
        organizationId: Number(this.cookieService.get('organizationId')),
        ispublic: this.isPublicValue,
      };
      this.saveManageProjectWorkFlowEvent.emit(manageProjectWorkFlowAddEditPayload);
      this.submitted = false;
    }
  }
}
